import { IdentityService } from './../../../common/service/identity.service';
import { Component, inject, OnInit } from '@angular/core';
import { UserService } from '../../../common/service/user.service';
import { Role } from '../../../core/auth/role.enum';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from '../../../common/helper/Constants';
import { CustomerService } from '../../../common/service/customer.service';
import { LoaderComponent } from '../../../common/component/loader/loader.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'gate-customer-impersonation',
  standalone: true,
  imports: [LoaderComponent,TranslatePipe],
  template: `<gate-loader [message]="'loading' | translate"></gate-loader>`,
})
export class CustomerImpersonationComponent implements OnInit {
  private userService = inject(UserService);
  private identityService = inject(IdentityService);
  private customerService = inject(CustomerService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private customerNumber: string = '';

  ngOnInit(): void {
    this.customerNumber = this.route.snapshot.params['customerNumber'] || '';
    if(!this.customerNumber) {
      this.router.navigate([Constants.routes.forbidden()]);
      return;
    }
    this.canImpersonate().then((canImpersonate) => {
      if (canImpersonate) {
        this.impersonateCustomer();
      } else {
        this.router.navigate([Constants.routes.forbidden()]);
      }
    });
  }

  canImpersonate(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.identityService
        .checkCustomerImpersonation(this.customerNumber)
        .then((canImpersonate) => {
          resolve(canImpersonate);
        })
        .catch(() => {
          resolve(false);
        });
    });
  }

  impersonateCustomer() {
    let customerName = '';
    this.customerService
      .getCustomerData(this.customerNumber)
      .then((customerData) => {
        customerName = customerData?.fullName;
      })
      .finally(() => {
        // 🚀 start impersonation for the required customer
        const userProfile = this.userService.getUserProfile();
        if (userProfile?.roles.includes(Role.AccountManager)) {
          this.userService.startImpersonation({
            impersonatedUserSubject: null,
            customerId: this.customerNumber,
            impersonatedCustomerName: customerName,
            impersonatedType: 'Customer',
            initiatorType: 'ACP_User',
            log: true
        }).finally(() => {
          this.router.navigate([Constants.routes.home()]);
        });
      }else{
        this.userService.switchCustomer(this.customerNumber);
      }
      });
  }
}
